import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDefineNameService } from './remoteOrderGroupDefineName.facade';
import { RemoteGroupOrderService } from '../../services/RemoteGroupOrder.service';

@Injectable()
export class RemoteOrderGroupDefineNameService implements IDefineNameService, OnDestroy {

  private _canStartDefineGroup: boolean = false;
  private _canStartDefineGroupSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private _remoteGroupOrderService: RemoteGroupOrderService) { }

  ngOnDestroy(): void {
  }

  /**
 * Initializes the component.
 * Fetches necessary data and sets the ability to define a group based on the max count.
 */
  public async initial() {
    const me = this;
    //TODO get data (Portal)
    const maxCountReached = false;//!Placeholder for testing
    me._setCanStartDefineGroup(!maxCountReached);
  }

  /**
 * Sets the ability to define a group.
 * If the current state differs from the new state, it updates the state and notifies subscribers.
 * @param canDefineGroup - A boolean indicating whether the user can define a group.
 */
  private _setCanStartDefineGroup(canDefineGroup: boolean): void {
    const me = this;
    if (me._canStartDefineGroup !== canDefineGroup) {
      me._canStartDefineGroup = canDefineGroup;
      me._canStartDefineGroupSubject.next(me._canStartDefineGroup);
    }
  }

  /**
 * Returns an observable that emits the current state of the ability to define a group.
 * @returns An observable of the canDefineGroup state.
 */
  public get canStartDefineGroup$(): Observable<boolean> {
    const me = this;
    return me._canStartDefineGroupSubject.asObservable();
  }
  /** Set group creator name */
  private _setCreatorName(creatorName: string) {
    const me = this;
    return me._remoteGroupOrderService.setCreatorName(creatorName);
  }
  /** Set group  name */
  private _setGroupName(groupName: string) {
    const me = this;
    return me._remoteGroupOrderService.setGroupName(groupName);
  }

  /**
   * @param creatorName - The name of the user/group creator.
   * @param group_name - The name of the group to be defined.
   * @returns A promise that resolves to the result of the group definition.
   */
  public async defineGroup(creatorName: string, groupName: string): Promise<void> {
    const me = this;
    me._setCreatorName(creatorName);
    me._setGroupName(groupName);
  }

}